import { App } from 'vue'
import 'vue3-toastify/dist/index.css'
import Vue3Toasity, { ToastContainerOptions } from 'vue3-toastify'

export function registerToastify(app: App<Element>) {
  app.use(Vue3Toasity, {
    autoClose: 6000,
    transition: 'slide',
    position: 'bottom-right',
    closeOnClick: false,
    hideProgressBar: true,
    clearOnUrlChange: false,
    limit: 5,
    newestOnTop: true,
    theme: 'auto',
  } satisfies ToastContainerOptions)
}
